import React, { useReducer } from 'react'
import moment from 'moment'
import Raports from './raports'
import RaportsTable from './raports-table'

const MONTH_LABELS = [
  'Tammi',
  'Helmi',
  'Maalis',
  'Huhti',
  'Touko',
  'Kesä',
  'Heinä',
  'Elo',
  'Syys',
  'Loka',
  'Marras',
  'Joulu',
  'Vuosi'
]

const initialState = {
  selectedMonth: moment().month(),
  startDate: moment()
    .startOf('month')
    .format('YYYY-MM-DD'),
  endDate: moment()
    .endOf('month')
    .format('YYYY-MM-DD'),
  raportData: null
}

function reducer(state, action) {
  switch (action.type) {
    case 'changeSelected':
      const { selectedMonth, endDate, startDate } = action

      return {
        ...state,
        selectedMonth,
        endDate,
        startDate
      }
    case 'changeSelectedDate':
      const { newDate, target } = action

      return {
        ...state,
        selectedMonth: null,
        [target]: newDate
      }
    case 'setRaportData':
      return {
        ...state,
        raportData: action.data
      }
    default:
      return state
  }
}

const Exports = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { startDate, endDate, raportData, selectedMonth } = state

  const setRaportData = dispatchFn => {
    return data => {
      dispatchFn({
        type: 'setRaportData',
        data
      })
    }
  }

  const changeSelectedDate = (newDate, target) => {
    dispatch({
      type: 'changeSelectedDate',
      newDate,
      target
    })
  }

  const clearDates = () => {
    dispatch({
      type: 'changeSelected',
      selectedMonth: null,
      startDate: '',
      endDate: ''
    })
  }

  const changeSelected = monthIndex => {
    if (monthIndex === 12) {
      const yearStart = moment()
        .startOf('year')
        .format('YYYY-MM-DD')
      const yearEnd = moment().format('YYYY-MM-DD')

      dispatch({
        type: 'changeSelected',
        selectedMonth: monthIndex,
        startDate: yearStart,
        endDate: yearEnd
      })

      return
    }

    dispatch({
      type: 'changeSelected',
      selectedMonth: monthIndex,
      startDate: moment(monthIndex + 1, 'M MM')
        .startOf('month')
        .format('YYYY-MM-DD'),
      endDate: moment(monthIndex + 1, 'M MM')
        .endOf('month')
        .format('YYYY-MM-DD')
    })
  }

  return (
    <div>
      <Raports
        startDate={startDate}
        endDate={endDate}
        selectedMonth={selectedMonth}
        monthLabels={MONTH_LABELS}
        onSelectMonth={changeSelected}
        onChangeDate={changeSelectedDate}
        onClearDates={clearDates}
        setRaportData={setRaportData(dispatch)}
      />

      {raportData && <RaportsTable raportData={raportData} />}
    </div>
  )
}

export default Exports
